module.exports = __webpack_public_path__ + "img/zip_reference_icon.c71c4707.svg";